import client from 'lib/sitecore-client';

// Wraps SitecoreClient.getData() to provide a compatible GraphQL client interface.
// All consumers retrieve a { request<T> } object — behaviour is unchanged.
const graphqlClientFactory = (_?: unknown) => ({
  request: <T>(query: string, variables?: Record<string, unknown>) =>
    client.getData<T>(query, variables),
});

export default graphqlClientFactory;
